export default class Element {
  constructor(data = {}) {
    this.description = data.description || "";
    this.adjuntos = data.adjuntos || [];
    this.checklist = data.checklist || [];
    this.puntaje = data.puntaje || 0;
    this.dificultad = data.dificultad || "";
    this.type = data.type || "textoLibre";
    this.participants = data.participants || [];
    this.topic = data.topic || 0;
    this.state = data.state || "";
    this.dateLimit = data.dateLimit || "";
    this.timeLimit = data.timeLimit || "";
    this.meeting = data.meeting || [];
    this.project = data.project || [];
    this.meetingMinute = data.meetingMinute || "";
    this.number = data.number || 0;
    this.sprint = data.sprint || "";
    this.disagreementFrom = data.disagreementFrom || "";
    this.blocked = data.blocked || false;
    this.blockedBy = data.blockedBy || "";
    this.postition = data.postition || "";
    this.isSort = data.isSort || "";
    this.si = data.si || 0;
    this.no = data.no || 0;
    this.abstencion = data.abstencion || 0;
    this.user_vote = data.user_vote || [];
    this.writer = data.writer || "";
  }
}
